import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import { HttpUtils } from 'common';

@Component({
    selector: 'hcsp-dashboard-embed',
    template: require('./hcsp-dashboard-embed.html'),
    styles: [require('./hcsp-dashboard-embed.scss')]
})

export default class HcspDashboardEmbedComponent implements OnInit {
    private isItDashboard: boolean = true;
    public hcspDashboardIframeUrl;
    public activityLogsIframeUrl;

    constructor(private route:ActivatedRoute, private sanitizer: DomSanitizer){
        this.hcspDashboardIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${HttpUtils.getUiMountPoint()}/hcsp-dashboard-ui/index.html`);
        this.activityLogsIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${HttpUtils.getUiMountPoint()}/hcsp-dashboard-ui/activity-logs.html`);
    }

    public ngOnInit() {
        this.route.data.subscribe(data => {
            this.isItDashboard = data.type === 'dashboard';
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/hcsp-dashboard/hcsp-dashboard-embed.ts